namespace TabAurous.Scheme {
    export interface SchemeMasterRow {
        SchemeId?: number;
        SchemeCode?: string;
        Description?: string;
        SchemeType?: number;
        Frequency?: number;
        Tenure?: number;
        AllowCancellation?: boolean;
        CancellationCharge?: number;
        SchemeAmount?: number;
        BonusType?: number;
        BonusValue?: number;
    }

    export namespace SchemeMasterRow {
        export const idProperty = 'SchemeId';
        export const nameProperty = 'SchemeCode';
        export const localTextPrefix = 'Scheme.SchemeMaster';
        export const deletePermission = 'Scheme:Master:Delete';
        export const insertPermission = 'Scheme:Master:Add';
        export const readPermission = '*';
        export const updatePermission = 'Scheme:Master:Edit';

        export declare const enum Fields {
            SchemeId = "SchemeId",
            SchemeCode = "SchemeCode",
            Description = "Description",
            SchemeType = "SchemeType",
            Frequency = "Frequency",
            Tenure = "Tenure",
            AllowCancellation = "AllowCancellation",
            CancellationCharge = "CancellationCharge",
            SchemeAmount = "SchemeAmount",
            BonusType = "BonusType",
            BonusValue = "BonusValue"
        }
    }
}
